import { isSceneEntered } from 'src/lib/stateUtils';
import { getPet } from '../pet';
import PopupMonitor from '../logic/PopupMonitor';
import { getTutorialServices } from '../tutorial/services/TutorialServices';
import { downscale } from 'src/conf/scale';
import StateObserver, { now, user } from 'src/StateObserver';
import * as Pet from 'src/replicant/pet';
import * as Fate from 'src/replicant/fate';
import { waitForMatch2Sequence } from '../minigame/match2-timestep/match2.sequence';
import { canSeeArena } from 'src/replicant/championsLeague/championsLeague.getters';

/**
 * Transition to the arena scene from the home scene. Will do nothing if already in the arena scene.
 * @returns
 */
export async function goToArenaFromHome() {
  // Can only go to arena from living room scene
  if (!isSceneEntered('livingRoom')) return;
  await getPet().moveTo({ scene: 'arena', location: 'c' });
}

/**
 * Transition to the home scene from the arena scene. Will do nothing if already in the home scene.
 * @returns
 */
export async function goToHomeFromArena() {
  // Can only go home from arena scene
  if (!isSceneEntered('arena')) return;
  await getPet().moveTo({ scene: 'livingRoom', location: 'c' });
}

/**
 * Check if pet is present in the screen and not locked somehow
 * @returns
 */
export function isPetPlayable() {
  const { user } = StateObserver.getState();
  const petExists = !!Pet.getters.getPetCreatedAt(user);
  const petInDaycare = Fate.getters.hasPermanentStatusEffect(
    user,
    'daycare',
    StateObserver.now(),
  );
  const appearanceLocked = getPet().appearance.isLocked();
  return petExists && !petInDaycare && !appearanceLocked;
}

/**
 * Play the Champions League tutorial, if suitable
 * @returns
 */
export async function playChampionsLeagueTutorial() {
  // Cannot play tutorial if there are any popup open
  if (PopupMonitor.isAnyPopupOpen()) return;

  // Cannot play tutorial if not in arena
  if (!isSceneEntered('arena')) return;

  // Check if already seen the tutorial
  if (user().championsLeague?.tutorialSeenAt) return;

  // Mark tutorial as seen
  await StateObserver.invoke.setChampionsLeagueTutorialSeen();

  // Only play tutorial if pet is playable
  await waitForMatch2Sequence();

  if (isPetPlayable()) {
    getPet().position.moveTo({
      scene: 'arena',
      location: 'c',
    });
    getPet().position.setWandering(false);
    // Hide et status animation while showing the tutorial
    getPet().entity.statusClip.updateOpts({
      opacity: 0,
    });
  }

  const { hand, overlay } = getTutorialServices();
  const height = StateObserver.getState().ui.screenSize.height;
  const locale = StateObserver.getLocale();
  overlay.addImage(`assets/ui/championsLeague/arena/tutorial_${locale}.png`, {
    width: locale === 'en' ? downscale(732) : downscale(490),
    height: locale === 'en' ? downscale(118) : downscale(113),
    y: height * 0.5 + 100,
  });
  overlay.show();
  await hand.show({ tag: 'championsLeagueTrophy', x: 150, y: 150 });
  await hand.waitForTap();
  overlay.hide();

  if (isPetPlayable()) {
    // Bring back status animation
    getPet().entity.statusClip.updateOpts({
      opacity: 1,
    });
    getPet().position.setWandering(true);
  }
}

/**
 * Post game sequence for champions league
 */
export async function championsLeaguePostGame() {
  if (!canSeeArena(user(), now())) return;
  await goToArenaFromHome();
}
